import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Card, Typography } from "@mui/material";

interface Props {
  data: { name: string; count: number }[];
}

const TopServicesChart = ({ data }: Props) => (
  <Card className="saloon-chart-card">
    <Typography variant="h6" gutterBottom>
      Top Services
    </Typography>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

export default TopServicesChart;
